import { useEffect, useState } from "react";
import { useApp } from "../../../context/AppContext";

//import resources
import { HiOutlineTrash } from "react-icons/hi2";

//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";


export default function CartItems({ item, setData }) {

    // Get locale
    const { t } = useTranslation();

    const {toCart, setToCart} = useApp();
    const [cartAmount, setCartAmount] = useState(toCart?.products?.[item?.product?.id] ? toCart?.products?.[item?.product?.id] : 0);


    const addToCart = (id, value) => {
        setToCart((prevCart) => {

            const updatedProducts = prevCart.products || {};
            updatedProducts[id] = value;
            
            return {
                ...prevCart,
                products: updatedProducts,
            };
        });
    };

    const changeCartAmount = (e, id) => {
        const value = e.target.value;
        setCartAmount(value);
        addToCart(id, value);
    };


    const removeCart = (id) => {

        setToCart((prevCart) => {
            
            const updatedProducts = prevCart.products || {};
            delete updatedProducts[id];
            
            return {
                ...prevCart,
                products: updatedProducts,
            };
        });


        setData(null);
        
    };
    


    return (
        <>
            <tr className="border-b hover:bg-gray-50 text-[13px] lg:text-[14px]">
                <td className="px-6 py-4">
                    <div className="flex items-center space-x-4">
                        <img
                            src={`${process.env.REACT_APP_API_URL}/storage/uploads/products/thumbs/large_${item.product.img}`}
                            alt={item.product.name}
                            className="w-12 h-12 object-cover rounded"
                        />
                        <span className="inline-block">{item.product.translations[0].name}</span>
                    </div>
                </td>
                <td className="px-6 py-4 text-gray-700 whitespace-nowrap">
                    {
                        item.product.discounted ? 
                        <>
                            <span className="text-[var(--orange)] font-bold">{item.product.discounted.toFixed(2)}</span>
                            <span className="text-gray-400 text-xs line-through ms-3">{item.product.price.toFixed(2)}</span>
                        </>
                        :
                        item.product.price.toFixed(2)
                    } ₾
                </td>
                <td className="px-6 py-4 text-gray-700">
                    <input
                        type="number"
                        min="1"
                        max={item.product.live_stock}
                        value={cartAmount}
                        onFocus={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                            if (!['ArrowUp', 'ArrowDown', 'Tab'].includes(e.key)) {
                                e.preventDefault();
                            }
                        }}
                        className="w-16 px-2 py-1 border rounded-md text-center"
                        onChange={(e)=>changeCartAmount(e, item.product.id)}
                    />
                    
                </td>
                <td className="px-6 py-4 text-gray-700 whitespace-nowrap">
                    {(item.product.discounted ? item.product.discounted * cartAmount : item.product.price * cartAmount).toFixed(2)} ₾
                </td>
                <td className="px-6 py-4 text-center">
                    <button
                        className="text-red-500 hover:text-red-700 focus:outline-none text-[22px]"
                        onClick={()=>removeCart(item.product.id)}
                    >
                        <HiOutlineTrash />
                    </button>
                </td>
            </tr>
        </>
    );
}
